import { TMP_ELEMENT_POSITION, TMP_ELEMENT_SIZE } from '../../shared/abstract-boxes';
import { resolveTranslationKey } from './whatsappMessageWithButtonsKeyResolver';

export function WhatsappMessageWithButtonsBoxViewConstructor(services, callbacks, context, siteTypeConfig) {

  let joint = services.joint;
  let companyId = context.companyId;
  let site = context.site;
  let scenarioId = context.scenarioId;

  return joint.shapes.html.AbstractBoxElementWithDragAndDropView.extend({
    isElementEditable: true,
    editElementModalController: 'editWhatsappMessageWithButtonsController',
    editElementModalTemplate: require('./editWhatsappMessageWithButtons.modal.html'),
    angularTemplate: `
  <div layout="column" class="whatsapp-message-with-buttons-box-content">
    <div ng-if="elementData.header.type == 'text'"><span>{{ elementData.header.text }}</span></div>
    <div ng-if="elementData.header.type == 'image'"><img class="image" jwt-src="{{ elementView.getPictureUrl() }}" width="100%"></div>
    <div ng-if="elementData.header.type == 'video'"><video class="video" jwt-src="{{ elementView.getVideoUrl() }}" width="50%" preload="" controls=""></video></div>
    <div ng-if="elementData.header.type == 'file'" layout="row"><md-icon aria-label="video">attachment</md-icon><span>{{ elementData.header.fileName }}</span></div>
    <div><span>{{ elementData.body.text ||  elementView.resolveTranslationKey('box_body_placeholder') | translate}}</span></div>
    <div layout="column" class="whatsapp-message-with-buttons">
        <md-button ng-click="elementView.addButton()"> {{ elementView.resolveTranslationKey('add_button') | translate}} </md-button>
    </div>
  </div>
`,
    initialize: function () {
      joint.shapes.html.AbstractBoxElementWithDragAndDropView.prototype.initialize.apply(this, arguments);
    },

    resolveTranslationKey: function (key) {
      return resolveTranslationKey(this.getType(), key);
    },

    getPictureUrl: function() {
      const header = this.angularScope.elementData.header;
      return header && header.pictureId ? services.MediasFactory.pictureUrl(companyId, header.pictureId) : '';
    },

    getVideoUrl: function() {
      const header = this.angularScope.elementData.header;
      return header && header.videoId ? services.MediasFactory.videoUrl(companyId, header.videoId) : '';
    },

    afterEditElement: function(oldElementData, newElementData) {
      this.resizeBox();
    },

    addButton: function () {
      // 4 because we always have a UserInput and only 3 buttons are allowed
      if (this.model.getEmbeddedCells().length < 4) {
        services.QuickRepliesFactory.createUniqueId(companyId, site.id, scenarioId)
          .then(response => {
            let answer = this.createButton(response.data.id);
            this.model.graph.addCell(answer);
            this.model.embed(answer);
            this.reorderChildren();
            this.resizeBox();
          }, services.AlertingFactory.httpErrorHandler());
      }
    },

    /**
     * Overrides superclass
     * The "UserInput" element always comes last
     */
    isChildAlwaysLast: function(child) {
      return child.get('type') === 'html.UserInput';
    },
    
    createButton: function (id,
                            position = TMP_ELEMENT_POSITION,
                            size = TMP_ELEMENT_SIZE,
                            elementData={}) {
      return new joint.shapes.html.WhatsappMessageWithButtonsButton({ id, position, size, elementData });

      // caller is responsible for calling addCell(answer), this.reorderChildren(), this.resizeQuestionBox(),
      // and this.updateValidity(), if and when necessary
    },

    // useful for drag and drop, see AbstractBoxElementWithDragAndDropView.repositionOtherChildren
    paddingTop: function() {
      return this.heightOfHTMLContent();
    }
  });
}
